/* ===== TRKVLT Micro-Animations JS =====
   Progressive enhancement only. Every function below is read-only /
   observational with respect to existing site logic:
   - Scroll reveal only ever ADDS a class to elements it finds; if it can't
     find them (different page, template variant, etc.) it simply does
     nothing — the page is already fully visible in the base CSS.
   - Add to Cart feedback watches the *existing* disabled attribute that
     theme.js already toggles during addToCart() — it never calls
     addToCart(), fetch, or the cart API itself.
   - Audio feedback listens to the *existing* 'trkvltplayerupdate' event
     that global-player.js already dispatches — it adds no listeners to
     the <audio> element and never calls play()/pause().
   - Artwork tilt only ever sets a CSS transform on its own wrapper element;
     it never touches the purchase card or any other element. */

(function () {
  var html = document.documentElement;
  if (html.dataset.animEnabled !== 'true') return;

  var prefersReduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ---- Scroll reveal ---- */
  function setupReveal() {
    if (html.dataset.animReveal !== 'true') return;
    var selectors = [
      '.pd-testimonials-section .pd-review-card',
      '.pd-faqcontact-section .pd-faqc-item',
      '.pd-related-section .bp-card',
      '.mtp-reveal-section'
    ];
    var found = false;
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (!el.classList.contains('trkvlt-reveal-item')) {
          el.classList.add('trkvlt-reveal-item');
          found = true;
        }
      });
    });
    if (!found) return;
    html.classList.add('trkvlt-anim-ready');

    if (prefersReduced || typeof IntersectionObserver === 'undefined') {
      document.querySelectorAll('.trkvlt-reveal-item').forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function () { entry.target.classList.add('is-revealed'); }, (i % 6) * 40);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.trkvlt-reveal-item:not(.is-revealed)').forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---- Add to Cart success feedback ---- */
  function setupAddToCartFeedback() {
    if (html.dataset.animButton !== 'true') return;
    ['pd-atc-btn', 'pd-sticky-atc-btn'].forEach(function (id) {
      var btn = document.getElementById(id);
      if (!btn || btn.dataset.trkvltAnimBound) return;
      btn.dataset.trkvltAnimBound = '1';
      btn.classList.add('trkvlt-btn-relative');

      var check = document.createElement('span');
      check.className = 'trkvlt-added-check';
      check.setAttribute('aria-hidden', 'true');
      check.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
      btn.appendChild(check);

      var wasDisabled = btn.disabled;
      new MutationObserver(function () {
        var isDisabled = btn.disabled;
        if (wasDisabled && !isDisabled) {
          check.classList.add('show');
          setTimeout(function () { check.classList.remove('show'); }, 900);
        }
        wasDisabled = isDisabled;
      }).observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    });
  }

  /* ---- Now-playing visual feedback ---- */
  function setupAudioFeedback() {
    if (html.dataset.animAudio !== 'true') return;
    if (window.trkvltAnimAudioBound) return;
    window.trkvltAnimAudioBound = true;

    function setGlow(playing) {
      ['gp-play', 'gp-exp-play'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.classList.toggle('trkvlt-playing-glow', playing);
      });
    }

    function updateActiveRowEq(playing) {
      // Clear any equalizer icon left over on ANY row first — when switching
      // directly from one playing track to another (no pause in between),
      // gp-active moves to the new row before this runs, so a check scoped
      // only to the (new) active row would miss the old row's leftover icon.
      document.querySelectorAll('.pd-track .trkvlt-eq').forEach(function (el) {
        el.remove();
      });
      if (!playing) return;
      var row = document.querySelector('.pd-track.gp-active .pd-track-name');
      if (!row) return;
      var eq = document.createElement('span');
      eq.className = 'trkvlt-eq';
      eq.setAttribute('aria-hidden', 'true');
      eq.innerHTML = '<span></span><span></span><span></span>';
      row.insertAdjacentElement('afterend', eq);
    }

    window.addEventListener('trkvltplayerupdate', function (e) {
      var playing = !!(e.detail && e.detail.playing);
      setGlow(playing);
      updateActiveRowEq(playing);
    });
  }

  /* ---- Product hero artwork tilt (desktop pointer devices only) ---- */
  function setupTilt() {
    if (html.dataset.animTilt !== 'true' || prefersReduced) return;
    if (!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches)) return;
    var wrap = document.querySelector('.pd-image');
    if (!wrap || wrap.dataset.trkvltTiltBound) return;
    wrap.dataset.trkvltTiltBound = '1';

    var raf = null;
    wrap.addEventListener('mousemove', function (e) {
      var rect = wrap.getBoundingClientRect();
      var px = (e.clientX - rect.left) / rect.width - 0.5;
      var py = (e.clientY - rect.top) / rect.height - 0.5;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        wrap.style.transform = 'perspective(900px) rotateY(' + (px * 5).toFixed(2) + 'deg) rotateX(' + (-py * 5).toFixed(2) + 'deg)';
      });
    }, { passive: true });
    wrap.addEventListener('mouseleave', function () {
      if (raf) cancelAnimationFrame(raf);
      wrap.style.transform = 'perspective(900px) rotateY(0deg) rotateX(0deg)';
    }, { passive: true });
  }

  function initAll() {
    setupReveal();
    setupAddToCartFeedback();
    setupAudioFeedback();
    setupTilt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-run for content swapped in by the site's existing AJAX navigation.
     Purely observational — watches #main-content for changes the same way
     global-player.js already replaces it; never touches navigation logic. */
  var mainEl = document.getElementById('main-content');
  if (mainEl && typeof MutationObserver !== 'undefined') {
    new MutationObserver(function () { initAll(); }).observe(mainEl, { childList: true });
  }
})();
